export default {
    Metadata: {
        Name: "RecordCount",
        Description: "Returns the total number of records for this form with any server filtering applied. If paging is enabled this returns the total records regardless of page size.",
        Syntax: "RecordCount()",
        Keywords: ['Records', 'Total'],
        Author: "DataVoke, Inc.",
        UpdatesOnData: true
    },
    execute() {
        let mvc = app.dv.helpers.exprEng.currexpression && app.dv.helpers.exprEng.currexpression.mvc;
        if (mvc != null) {
            if (mvc.pageRecordSize === 0) {
                // record page sizing is not in use, return the actual number of records loaded.
                return mvc.records.count();
            }
            else {
                // return the total number of records on the service for the form criteria returned due to record page sizing.
                return mvc.totalRecordCount || 0;
            }
        }
        else {
            // unknown; return 0.
            return 0;
        }
    },
};

